import { provideOAuthClient } from 'angular-oauth2-oidc';
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';

import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { importProvidersFrom, provideAppInitializer } from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { provideTransloco, provideTranslocoTranspiler } from '@jsverse/transloco';
import { provideGemsApi } from '@ng-gems/api';
import { IntlMessageFormatTranspiler } from '@ng-gems/utils';

import { AppComponent } from '@app/app.component';
import { provideApiInit, provideAppInit } from '@app/app.init';
import { provideHttpInterceptors } from '@app/core/providers/http-interceptor.provider';
import { provideMaterialConfig } from '@app/core/providers/material.provider';
import { provideLocalId, withWattSonTranslocoOptions } from '@app/core/providers/translation.provider';
import { routes } from '@app/pages/pages.routes';

(window as any).pdfWorkerSrc = '/assets/js/pdf.worker.min.mjs';

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule), // 4.23 kB
    provideHttpClient(withInterceptorsFromDi(), withFetch()), // 8.88 kB
    provideAnimationsAsync(), // 4.46 kB
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })), // 4.42 kB + x.xx KB
    provideTransloco(withWattSonTranslocoOptions()), // 25.54 kB
    provideLocalId(),
    provideTranslocoTranspiler(IntlMessageFormatTranspiler),
    provideOAuthClient(undefined, JwksValidationHandler), // 49.89 kB
    provideMaterialConfig(), // 87.20 kB
    provideHttpInterceptors(),
    provideAppInitializer(provideAppInit),
    provideGemsApi(provideApiInit),
  ],
})
  .then()
  .catch();
